module.exports = __webpack_public_path__ + "static/media/up_arrow.f5233be6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/asset/up_arrow.svg
// module id = 984
// module chunks = 0